import { Popup } from '@/ui/overlays/Popup'
import * as React from 'react'

import { format as formatFns } from 'date-fns'
import { ExchangeRateSourceType } from 'app/constants/configuration/exchangeRateSourceType'
import { faClose, faDownload } from '@fortawesome/free-solid-svg-icons'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { Button } from '@/ui'
import { DateField } from '@/ui/form/controls/DateField'

type Props = {
  sourceType: ExchangeRateSourceType
  isOpen?: boolean
  handleClose?: () => void
  handleDownload?: (from: string, to: string) => void
}

function formatDate(date: Date, format: string) {
  return formatFns(date, format)
}

export const ExchangeRateModal = ({
  handleDownload,
  sourceType,
  isOpen,
  handleClose,
}: Props) => {
  const { tSafe } = useLocalize()
  const [dateStart, setDateStart] = React.useState<string>(
    formatDate(new Date(), 'YYYY-MM-DD'),
  )
  const [dateEnd, setDateEnd] = React.useState<string>(
    formatDate(new Date(), 'YYYY-MM-DD'),
  )

  const _handleDownload = () => handleDownload(dateStart, dateEnd)

  return (
    <Popup open={isOpen} layer="modal" contentClassName="tw-w-[400px]">
      <div className="tw-mb-5 tw-text-lg tw-font-bold">
        {`${tSafe('newDelegation.download-exchange-rate', 'Download Exchange Rate')} ${ExchangeRateSourceType[sourceType]}`}
      </div>
      <div className="tw-flex tw-flex-col tw-gap-2">
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
          <label className="tw-w-[80px]">
            {tSafe('configuration.exchangeRates.date-from', 'Od dnia')}:
          </label>
          <DateField
            classNameWrapper="tw-flex-1"
            value={dateStart}
            setValue={setDateStart}
          />
        </div>
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
          <label className="tw-w-[80px]">
            {tSafe('configuration.exchangeRates.date-to', 'Do dnia')}:
          </label>
          <DateField
            value={dateEnd}
            setValue={setDateEnd}
            classNameWrapper="tw-flex-1"
          />
        </div>
      </div>
      <div className="tw-mt-5 tw-flex tw-items-center tw-justify-end tw-gap-2">
        <Button
          onClick={handleClose}
          text={tSafe('answer.cancel', 'Cancel')}
          size="sm"
          faLeadingIcon={faClose}
        />
        <Button
          onClick={_handleDownload}
          text={tSafe('answer.download', 'Download')}
          size="sm"
          faLeadingIcon={faDownload}
        />
      </div>
    </Popup>
  )
}
